import React, { FC, useCallback } from 'react';
import _isArray from 'lodash/isArray';
import _isBoolean from 'lodash/isBoolean';
import _isString from 'lodash/isString';
import _map from 'lodash/map';
import _take from 'lodash/take';
import UncontrolledTooltip from '@minecraft.uncontrolled-tooltip';
import { CoreTheme as theme } from '@minecraft.themes';
import { useTranslation } from '@blocs.i18n';
import { PillType } from '../../../shared/utils';
import { Wrapper, PillText, ClearButton, ClearIcon } from './FilterOverlayBreadboxPillStyles';

type Props = {
  pillKey: string;
  pill: PillType;
  handleClear: () => void;
  className?: string;
};

const getPillText = (pill: PillType): string => {
  if (_isArray(pill.value) && pill.value.length > 1) {
    return `${pill.name} (${pill.value.length})`;
  }

  return pill.name;
};

const FilterOverlayBreadboxPill: FC<Props> = ({ pillKey, pill, handleClear, className }) => {
  const { t } = useTranslation();
  const renderPillTooltip = useCallback((): JSX.Element => {
    const renderTooltipContent = (): JSX.Element => {
      if (_isArray(pill.value) && pill.value.length > 0) {
        const visibleItems = _take(pill.value, 20);
        const hiddenItemsCount = pill.value.length - visibleItems.length;

        return (
          <>
            {_map(visibleItems, (item) => (
              <div key={item?.value || item}>{item?.label || item}</div>
            ))}
            {hiddenItemsCount > 0 && (
              <div>
                +{hiddenItemsCount} {t('common:label.more')}
              </div>
            )}
          </>
        );
      }

      if (_isString(pill.value)) {
        return <div>{pill.value}</div>;
      }

      return null;
    };

    return (
      !_isBoolean(pill.value) && (
        <UncontrolledTooltip placement="top" target={pillKey}>
          {renderTooltipContent()}
        </UncontrolledTooltip>
      )
    );
  }, [pill.value]);

  return (
    <>
      <Wrapper id={pillKey} className={className}>
        <PillText>{getPillText(pill)}</PillText>
        <ClearButton
          onClick={(event): void => {
            event.stopPropagation();

            handleClear();
          }}
        >
          <ClearIcon name="close" color={theme.colors.primary.white} />
        </ClearButton>
      </Wrapper>
      {renderPillTooltip()}
    </>
  );
};

export default FilterOverlayBreadboxPill;
